
// Define the subscription plan feature interface
export interface SubscriptionPlanFeature {
  name: string;
  included: boolean;
  highlight?: boolean;
  limit?: string;
}

// Define the subscription plan interface
export interface SubscriptionPlan {
  id: string;
  name: string;
  monthlyPrice: number;
  quarterlyPrice: number;
  yearlyPrice?: number;
  quarterlyDiscount: number;
  yearlyDiscount?: number;
  description: string;
  features: SubscriptionPlanFeature[];
  maxReferrals: number;
  maxManagers: number;
  maxReferralLinks: number;
  recommended?: boolean;
  badgeText?: string;
}

export const subscriptionPlans: SubscriptionPlan[] = [
  {
    id: 'starter',
    name: 'Starter',
    monthlyPrice: 39,
    quarterlyPrice: 99,
    yearlyPrice: 378,
    quarterlyDiscount: 15,
    yearlyDiscount: 20,
    description: 'Perfect for small businesses just getting started with referrals',
    features: [
      { name: 'Custom domain', included: true },
      { name: 'White-labeled experience', included: true },
      { name: 'Email notifications', included: true },
      { name: 'SMS notifications', included: false },
      { name: 'Automated follow-ups', included: false },
      { name: 'API access', included: false },
      { name: 'Priority support', included: false }
    ],
    maxReferrals: 25,
    maxManagers: 1,
    maxReferralLinks: 5
  },
  {
    id: 'growth',
    name: 'Growth',
    monthlyPrice: 79,
    quarterlyPrice: 202,
    yearlyPrice: 758,
    quarterlyDiscount: 15,
    yearlyDiscount: 20,
    description: 'For businesses ready to scale their referral program',
    features: [
      { name: 'Custom domain', included: true },
      { name: 'White-labeled experience', included: true },
      { name: 'Email notifications', included: true },
      { name: 'SMS notifications', included: true },
      { name: 'Automated follow-ups', included: true },
      { name: 'API access', included: false },
      { name: 'Priority support', included: false }
    ],
    maxReferrals: 100,
    maxManagers: 3,
    maxReferralLinks: 15,
    recommended: true,
    badgeText: 'MOST POPULAR'
  },
  {
    id: 'professional',
    name: 'Professional',
    monthlyPrice: 149,
    quarterlyPrice: 380,
    yearlyPrice: 1430,
    quarterlyDiscount: 15,
    yearlyDiscount: 20,
    description: 'Advanced features for established businesses',
    features: [
      { name: 'Custom domain', included: true },
      { name: 'White-labeled experience', included: true },
      { name: 'Email notifications', included: true },
      { name: 'SMS notifications', included: true },
      { name: 'Automated follow-ups', included: true },
      { name: 'API access', included: true },
      { name: 'Priority support', included: true }
    ],
    maxReferrals: 500,
    maxManagers: 10,
    maxReferralLinks: 50
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    monthlyPrice: 299,
    quarterlyPrice: 763,
    yearlyPrice: 2870,
    quarterlyDiscount: 15,
    yearlyDiscount: 20,
    description: 'Enterprise-grade solution for high-volume businesses',
    features: [
      { name: 'Custom domain', included: true },
      { name: 'White-labeled experience', included: true },
      { name: 'Email notifications', included: true },
      { name: 'SMS notifications', included: true },
      { name: 'Automated follow-ups', included: true },
      { name: 'API access', included: true },
      { name: 'Priority support', included: true },
      { name: 'Custom integrations', included: true, highlight: true },
      { name: 'Dedicated account manager', included: true, highlight: true }
    ],
    maxReferrals: 5000,
    maxManagers: 50,
    maxReferralLinks: 200
  }
];
